function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import OrganizationMembershipModalBox from '../OrganizationMembershipModalBox';
var _React_PureComponent;
class CancelInvitationModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress && !isInProgress && !hasErrors) {
            this.props.onClose();
        }
    }
    renderCancelBtn() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-6",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: App.messages.buttons.cancel,
                className: "btn--block",
                isDisabled: this.props.isInProgress,
                onClick: this.props.onClose
            })
        });
    }
    renderSubmitBtn() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-6",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.cancelInvitation,
                className: "btn--block btn--filled",
                isInProgress: this.props.isInProgress,
                onClick: this.props.onSubmit
            })
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                this.renderCancelBtn(),
                this.renderSubmitBtn()
            ]
        });
    }
    render() {
        const { organizationMembership } = this.props;
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.CANCEL_INVITATION_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.cancelInvitation,
            onClose: this.props.onClose,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mb-7",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.cancelInvitation))
                }),
                /*#__PURE__*/ _jsx(OrganizationMembershipModalBox, {
                    organizationMembership: organizationMembership
                }),
                this.renderActions()
            ]
        });
    }
}
_define_property(CancelInvitationModal, "propTypes", {
    // Explicit props
    openModalId: PropTypes.string,
    adminOrganizationMembership: PropTypes.object,
    organizationMembership: shapes.organizationMembership,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Explicit actions
    onClose: PropTypes.func,
    onSubmit: PropTypes.func
});
const mapStateToProps = (state)=>({
        isInProgress: selectors.isCancelInvitationInProgress(state),
        hasErrors: selectors.hasCancelInvitationErrors(state)
    });
const mapDispatchToProps = (dispatch, props)=>({
        onSubmit: ()=>dispatch(actions.cancelInvitation(props.organizationMembership, props.adminOrganizationMembership))
    });
const ConnectedCancelInvitationModal = connect(mapStateToProps, mapDispatchToProps)(CancelInvitationModal);
export default ConnectedCancelInvitationModal;
